import {
	useFetch as useFetchCore,
	UseFetchHookOutput,
	UseFetchInput as UseFetchInputCore,
} from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

import { useGtm } from '../useGtm';
import { useLoader } from '../useLoader';
import { useHideScroll } from '../useLockScroll';
import { useModal } from '../useModal';

interface UseFetchInput<TInput, TOutput> extends Omit<UseFetchInputCore<TInput, TOutput>, 'options'> {
	notShowLoading?: boolean;
}

export const useFetch = <TInput, TOutput>(
	input: Omit<UseFetchInput<TInput, TOutput>, 'options'>
): UseFetchHookOutput<TInput, TOutput> => {
	const { fetchFn, onSuccess, onError, notShowLoading = false } = input;

	const { hide, show: showLoader } = useLoader('global');
	const { show: showModal } = useModal('genericError');
	const { disable } = useHideScroll();

	const { sendEvent } = useGtm();

	return useFetchCore<TInput, TOutput>({
		fetchFn,
		onError: (err: any) => {
			if (onError) {
				onError(err);
			} else {
				sendEvent({
					// cSpell:disable-next-line
					eName: 'modal-erro',
					param_01: err?.data?.errorInfo?.code,
					param_02: err?.data?.errorInfo?.description,
				});
				disable();
				showModal();
			}
		},
		onSuccess,
		options: notShowLoading
			? undefined
			: {
					loadingFunctions: {
						hide,
						show: showLoader,
					},
			  },
	});
};
